import type { MenuDto } from 'types/menu';

type LooseMenu = Record<string, unknown> & { Children?: unknown; children?: unknown };

function pickStr(o: LooseMenu, ...keys: string[]): string {
  for (const k of keys) {
    const v = o[k as keyof LooseMenu] ?? o[k as never];
    if (v != null && v !== '') return String(v);
  }
  return '';
}

function pickNum(o: LooseMenu, ...keys: string[]): number {
  for (const k of keys) {
    const v = o[k as keyof LooseMenu] ?? o[k as never];
    if (v === 0) return 0;
    if (v != null && v !== '' && !Number.isNaN(Number(v))) return Number(v);
  }
  return 0;
}

/**
 * The API may serialize with camelCase (default) or PascalCase. If every node
 * deserializes with menuId = 0, React keys collapse and the drawer looks empty.
 */
function normalizeMenuNode(n: unknown): MenuDto {
  if (n == null || typeof n !== 'object') {
    return { menuId: 0, name: '', key: '', path: null, parentId: null, children: [] };
  }
  const o = n as LooseMenu;
  const c = o.children ?? o.Children;
  const arr: unknown[] = Array.isArray(c) ? c : [];
  const menuId = pickNum(o, 'menuId', 'MenuId');
  const name = pickStr(o, 'name', 'Name');
  const key = pickStr(o, 'key', 'Key');
  const pathRaw = o.path ?? o.Path;
  const path = pathRaw == null || pathRaw === '' ? null : String(pathRaw);
  const parentRaw = o.parentId ?? o.ParentId;
  const parentId = parentRaw === null || parentRaw === undefined || parentRaw === '' ? null : Number(parentRaw);
  return {
    menuId,
    name,
    key,
    path: path as string | null,
    parentId: parentId != null && !Number.isNaN(parentId) ? parentId : null,
    children: arr.map((x) => normalizeMenuNode(x))
  };
}

export function normalizeMenuTree(menus: unknown): MenuDto[] {
  if (!Array.isArray(menus)) return [];
  return menus.map((m) => normalizeMenuNode(m));
}
